module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "ui-content edi-mobilecheck",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onMobileSubmit.apply(null, arguments)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-one-item"
  }, [_c('div', {
    staticClass: "ui-col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui-col-4 ui-align-right"
  }, [_c('mobile-code', {
    attrs: {
      "type": 2,
      "mobile": _vm.telephone
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    class: {
      'ui-disable': _vm.submitDisable
    },
    attrs: {
      "type": "submit",
      "value": "确定"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mobile fieldset-1"
  }, [_vm._v("\n\t\t请先完成验证，已发送验证码短信到"), _c('br'), _vm._v(" "), _c('b', [_vm._v("186*****654")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad16e8fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MobileCheck.vue
// module id = 612
// module chunks = 1